import { useTranslation } from 'react-i18next'

import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

type Props = {
  /** The methods this screen presents, with their labels. */
  apms: readonly { key: string; label: string }[]
  /** From `processors.apmCapabilities`: what the processor's own Stripe account will not charge. */
  capabilities?: { inactiveOnAccount: readonly string[] }
}

/**
 * Says why a method the merchant may have enabled before is no longer offered:
 * their own Stripe account will not charge it (#TAG-3194). Without it, Affirm
 * would simply vanish from the list.
 */
export function ApmInactiveOnAccountNotice({ apms, capabilities }: Props) {
  const { t } = useTranslation('processors')
  const labels = apms
    .filter((apm) => capabilities?.inactiveOnAccount.includes(apm.key))
    .map((apm) => apm.label)
  if (labels.length === 0) return null

  return (
    <Card className="border-dashed">
      <CardHeader className="py-4">
        <CardTitle className="text-sm font-medium">{t('apmInactiveOnStripeAccountTitle')}</CardTitle>
        <CardDescription className="text-xs">
          {t('apmInactiveOnStripeAccountDescription', { methods: labels.join(', ') })}
        </CardDescription>
      </CardHeader>
    </Card>
  )
}
